module.exports = {"data":{"markdownRemark":{"html":"<p>SubFire 3 Tags is an upcoming desktop application for editing ID3 tags in files and organizing them on your local file system. It is a work in progress and has not been released yet.</p>\n<p>It is currently being implemented with React and Material-UI, packaged through nw-js.</p>","frontmatter":{"path":"/SubFire3Tags","title":"SubFire 3 Tags","summary":"A Desktop ID3 Tag Editor"}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sub-fire-3-tags.json
// module id = 399
// module chunks = 37432641236680